<div *ngIf="data">
  <div id="head">
    <div id="closeBtn">
      <span (click)="close();">×</span>
    </div>
    <div id="title" class="fontSize16">
        毕业典礼
    </div>
  </div>

  <div id="overview">
    <div id="space1"></div>
    <div id="headPortrait"></div>
    <div id="name" class="fontSize18">{{data.userName}}</div>
    <div id="companyName" class="fontSize14">{{data.companyName}}</div>
    <div id="totalCountWrap">
      <div id="totalCourse" class="fontSize12">
        <span class="fontSize26">{{data.lessonCount}}</span> 门<br/>
        学习总课程数
      </div>
      <div id="totalExercise" class="fontSize12">
        <span class="fontSize26">{{data.questionCount}}</span> 个<br/>
        完成情景模拟
      </div>
    </div>
  </div>

  <div id="certificate" *ngIf="data.personalReportStatus==1">
      <div id="certificateObject" class="fontSize27">
        {{data.userName}}
      </div>
  </div>

  <div id="space2" *ngIf="data.personalReportStatus==1"></div>

  <div id="subtitle" class="fontSize16">
    能力增长图
  </div>

  <div id="barWrap" *ngIf="levelArray.length<=2">
      <div class="barItem" *ngFor="let item of levelArray;let i=index" [style.marginTop]="i==1?'0.9rem':''">
          <div class="barTitle fontSize16">
            {{item.abilityName}}
          </div>
          <div class="barMain">
              <div class="barMainType fontSize16">
                 能力诊断
              </div>
              <div class="barBottom">
                  <div class="barTop barTop1 level{{item.preSurveyLevel}}"></div>
              </div>
              <div class="barMainLevel fontSize16">
                L{{item.preSurveyLevel}}<span class="fontSize14">&nbsp;/&nbsp;L7</span>
              </div>
          </div>
        <div class="barMain">
          <div class="barMainType fontSize16">
            能力考核
          </div>
          <div class="barBottom">
            <div class="barTop barTop2 level{{item.postSurveyLevel}}"></div>
          </div>
          <div class="barMainLevel fontSize16">
            L{{item.postSurveyLevel}}<span class="fontSize14">&nbsp;/&nbsp;L7</span>
          </div>
        </div>
      </div>
  </div>

    <div id="radar" *ngIf="levelArray.length>2"></div>

  <div id="personalitiesBtn" class="fontSize16" (click)="onPersonalitiesBtnClick()">
    个性画像
  </div>

    <div *ngIf="characterReport&&characterReport.id" id="dnaReport">
        <div id="dnaReportTitle" class="fontSize21">
            {{data.userName}}的“领导力DNA报告”
        </div>


        <div class="dnaItem">
            <div class="dnaTitle fontSize18">
                <span class="dnaTitle1">严谨</span>&nbsp;&nbsp;&nbsp;<span class="dnaTitle2">{{characterReport.responsibility}}</span><span class="fontSize14">分</span>
            </div>
            <div class="dnaContent fontSize16 lineHeight24">
                <i>“愿意遵守规范，为达成目标而努力的程度。”</i><br/><br/>
                <div [innerHtml]="characterReport.responsibility_description"></div>
            </div>
        </div>

        <div class="dnaItem">
            <div class="dnaTitle fontSize18">
                <span class="dnaTitle1">外向</span>&nbsp;&nbsp;&nbsp;<span class="dnaTitle2">{{characterReport.extroversion}}</span><span class="fontSize14">分</span>
            </div>
            <div class="dnaContent fontSize16 lineHeight24">
                <i>“对人际互动和社会认同的需求程度。”</i><br/><br/>
                <div [innerHtml]="characterReport.extroversion_description"></div>
            </div>
        </div>

        <div class="dnaItem">
            <div class="dnaTitle fontSize18">
                <span class="dnaTitle1">情绪稳定</span>&nbsp;&nbsp;&nbsp;<span class="dnaTitle2">{{characterReport.emotionality}}</span><span class="fontSize14">分</span>
            </div>
            <div class="dnaContent fontSize16 lineHeight24">
                <i>“对情绪的体验和情感调节的水平。”</i><br/><br/>
                <div [innerHtml]="characterReport.emotionality_description"></div>
            </div>
        </div>

        <div class="dnaItem">
            <div class="dnaTitle fontSize18">
                <span class="dnaTitle1">开放</span>&nbsp;&nbsp;&nbsp;<span class="dnaTitle2">{{characterReport.open}}</span><span class="fontSize14">分</span>
            </div>
            <div class="dnaContent fontSize16 lineHeight24">
                <i>“对新事物的态度倾向。”</i><br/><br/>
                <div [innerHtml]="characterReport.open_description"></div>
            </div>
        </div>

        <div class="dnaItem">
            <div class="dnaTitle fontSize18">
                <span class="dnaTitle1">亲和</span>&nbsp;&nbsp;&nbsp;<span class="dnaTitle2">{{characterReport.delightful}}</span><span class="fontSize14">分</span>
            </div>
            <div class="dnaContent fontSize16 lineHeight24">
                <i>“愿意关心并理解他人感受的倾向。”</i><br/><br/>
                <div [innerHtml]="characterReport.delightful_description"></div>
            </div>
        </div>
    </div>

  <div id="noDnaReport" *ngIf="!(characterReport&&characterReport.id)">
    <div id="noDnaReportPic"></div>
    <div id="noDnaReportText" class="fontSize16">未做领导力DNA测验</div>
  </div>

  <div id="closeBtnReport2" (click)="onCloseBtnReportClick()"></div>

  <div id="shade"></div>

  <div id="space3"></div>

</div>



// WEBPACK FOOTER //
// ./src/app/graduation-new/graduation-new.component.html